export const ENVIRONMENT_OPTIONS = [
  { label: 'QA1', value: 'qa1' },
  { label: 'QA2', value: 'qa2' },
  { label: 'QA3', value: 'qa3' },
  { label: 'QA4', value: 'qa4' },
  { label: 'QA5', value: 'qa5' },
  { label: 'QA6', value: 'qa6' },
  { label: 'QA7', value: 'qa7' },
  { label: 'QA8', value: 'qa8' },
  { label: 'QA9', value: 'qa9' },
  { label: 'QA10', value: 'qa10' },
  { label: 'QA12', value: 'qa12' },
  { label: 'SBX1', value: 'sbx1' },
  { label: 'SLS1', value: 'sls1' },
  { label: 'SLS2', value: 'sls2' },
  { label: 'STG1', value: 'stg1' },
  { label: 'STG2', value: 'stg2' },
  { label: 'STG3', value: 'stg3' },
  { label: 'STG6', value: 'stg6' },
  { label: 'INT1', value: 'int1' },
  { label: 'INT4', value: 'int4' },
  { label: 'INT6', value: 'int6' },
  { label: 'PRD0', value: 'prd0' },
  { label: 'PRD1', value: 'prd1' },
  { label: 'PRD2', value: 'prd2' },
  { label: 'PRD3', value: 'prd3' },
  { label: 'PRD5', value: 'prd5' },
  { label: 'PRD6', value: 'prd6' },
  { label: 'PRD9', value: 'prd9' },
  { label: 'PRF1', value: 'prf1' },
  { label: 'PRF2', value: 'prf2' },
  { label: 'PRF3', value: 'prf3' },
  { label: 'Local', value: 'local' },
  { label: 'LocalPS', value: 'localPS' }
] as const;

export type EnvironmentValue = (typeof ENVIRONMENT_OPTIONS)[number]['value'];

export const DEFAULT_DEVELOPMENT_ENVIRONMENT = 'qa1' as const;
